// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.finans-page {
  width: 100%;
  min-height: 100%;
}

.finans-page .ant-tabs-content-holder {
  overflow-x: auto;
}

.finans-data-table {
  width: 100%;
}

/* Keep the new-record / action toolbar tidy on narrow screens */
.finans-data-table .ant-space-item {
  margin-bottom: 4px;
}

/* Dark theme: align table surfaces with the app's CSS variables */
body.dark-theme .finans-page .ant-card,
body.dark-theme .finans-page .ant-table {
  background: var(--dark-bg-secondary, #1f1f1f);
}

body.dark-theme .finans-page .ant-table-cell {
  background: transparent;
}

body.dark-theme .finans-page .ant-tabs-tab {
  color: var(--color-text, inherit);
}

/* Amounts: keep on one line, right-aligned feel for numeric columns */
.finans-data-table .ant-table-cell span {
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/finans/Finans.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,sEAAsE;AACtE;EACE,mBAAmB;AACrB","sourcesContent":[".finans-page {\n  width: 100%;\n  min-height: 100%;\n}\n\n.finans-page .ant-tabs-content-holder {\n  overflow-x: auto;\n}\n\n.finans-data-table {\n  width: 100%;\n}\n\n/* Keep the new-record / action toolbar tidy on narrow screens */\n.finans-data-table .ant-space-item {\n  margin-bottom: 4px;\n}\n\n/* Dark theme: align table surfaces with the app's CSS variables */\nbody.dark-theme .finans-page .ant-card,\nbody.dark-theme .finans-page .ant-table {\n  background: var(--dark-bg-secondary, #1f1f1f);\n}\n\nbody.dark-theme .finans-page .ant-table-cell {\n  background: transparent;\n}\n\nbody.dark-theme .finans-page .ant-tabs-tab {\n  color: var(--color-text, inherit);\n}\n\n/* Amounts: keep on one line, right-aligned feel for numeric columns */\n.finans-data-table .ant-table-cell span {\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
